/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Return the label for the given language
    function putLabel(lang) {
      const translations = {
        es: {
          manageCookies: "Gestionar cookies"
        },
        en: {
          manageCookies: "Manage cookies"
        },
        ca: {
          manageCookies: "Gestionar cookies"
        },
        pt: {
          manageCookies: "Gerenciar cookies"
        },
        fr: {
          manageCookies: "Gérer les cookies"
        }
      };

      return translations[lang]?.manageCookies;
    }

    // Word break ---------------
    let heading = document.querySelector('.tlg-line-break');

    if (heading) {
      let words = heading.textContent.split('-');
      heading.innerHTML = words.join('<br>');
    }

    // Counter ---------------

    let counter = document.querySelector('.tlg-counter');

    if (counter) {
      const num_ref = counter.querySelector('.num');
      let num = parseInt(num_ref.textContent);
      num_ref.textContent = num.toLocaleString('es-ES');

      setInterval(function () {
        num += 2;
        num_ref.textContent = num.toLocaleString('es-ES');
      }, 3000);
    }

    // Register form---------------

    function validarDNI(dni) {
      const dniRegex = /^(\d{8})([A-Z])$/i;
      const match = dni.toUpperCase().match(dniRegex);
      if (!match) return false;

      const numero = parseInt(match[1], 10);
      const letra = match[2];
      const letras = "TRWAGMYFPDXBNJZSQVHLCKE";
      const letraEsperada = letras[numero % 23];

      return letra === letraEsperada;
    }

    function validarDoB(dob) {
      try {
        const fecha = new Date(dob);
        if (fecha.getFullYear() < 1900 || fecha.getFullYear() > new Date().getFullYear()) {
          return false;
        }

        return true;
      } catch (err) {
        return false;
      }
    }

    function showError(input, message) {
      if (!input || !input.closest) {
        return false;
      }

      const errorSpan = input.closest('.form-field').querySelector('.tlg-error__span');
      errorSpan.textContent = message;
      errorSpan.style.display = 'block';
      return true;
    }

    function submitForm(form) {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        nativeSubmit();
      }
    }

    // main flow ---
    // const menuFooter = document.querySelector('.supporting-menu__copyright');
    // if (menuFooter) {
    //   let li = document.createElement('li');
    //   li.addEventListener('click', function (e) {
    //     const a = document.createElement('a');
    //     a.href = '#shopifyReshowConsentBanner';
    //     a.style.display = 'none';
    //     document.body.appendChild(a);
    //     a.click();
    //     a.remove();
    //   });
    //   // li.textContent = 'Gestionar cookies';
    //   li.textContent = putLabel(document.documentElement.lang);
    //   li.style.cursor = 'pointer';


    //   menuFooter.appendChild(li);
    // }

    const form = document.getElementById('create_customer');
    if (form) {
      const btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          form.classList.remove('tlg-form__error');
          form.querySelectorAll('.tlg-error__span').forEach(span => {
            span.removeAttribute("style");
          });

          let formValid = true;

          // const firtsName = form.querySelector('#first_name');
          // const lastName = form.querySelector('#last_name');
          const dni = form.querySelector('#dni');
          const dob = form.querySelector('#dob');
          const password = form.querySelector('#password');
          const email = form.querySelector('#email');
          const phone = form.querySelector('#phone');

          if (!validarDNI(dni.value)) {
            showError(dni, 'DNI no válido');
            formValid = false;
          }

          if (!validarDoB(dob.value)) {
            showError(dob, 'Fecha de nacimiento no válida');
            formValid = false;
          }

          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
            showError(email, 'Email no válido');
            formValid = false;
          }

          if (!/^(?:\+34|0034)?[6-9]\d{8}$/.test(phone.value)) {
            showError(phone, 'Teléfono no válido');
            formValid = false;
          }

          if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_\-+=<>?{}[\]~|.,:;]{8,}$/.test(password.value)) {
            showError(password, 'La contraseña debe tener al menos 8 caracteres, una mayúscula y un número.');
            formValid = false;
          }

          if (formValid) {
            submitForm(form);
          } else {
            form.classList.add('tlg-form__error');
          }
        }, true);
      }
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
